module.exports = __webpack_public_path__ + "static/media/wirebasket-H1.9424a332.png";